import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';

// CLOUDWEB-19550
// Промо - Генерация и изменения стиля письма

/** id промо - для включения нужно будет включать фичу 3promo-enable-{id} */
export const PROMO_ID = 'ai-letter-style-promo';
/** Ключ для локалстораджа от баннера */
export const storageKeyForBanner = `${PROMO_ID}-2`;

/** Временной промежуток между показами одной и той же промки, в секундах */
export const showInterval: number = +getFeature(`${PROMO_ID}-show-interval`) || 604800;
/** Максимальное количество закрытий промки (на крестик в баннере / на primary кнопку) */
export const closeLimit: number = +getFeature(`${PROMO_ID}-close-limit`) || 3;
/** Максимальное количество показов, в которых не взаимодействуют с промкой */
export const showLimit: number = +getFeature(`${PROMO_ID}-show-limit`) || 3;

export const isFeatureAiLetterPromo = isFeature('3promo-enable-ai-letter-style-promo');

export const trial256gbAiLetterPromo = getFeature('ai-letter-style-promo-trial') || 'W256GB_1m_letter_style_discount_force_trial';
